import apiCall from '../../../../data/app/apiCall';

export const fetchReport = (uniqueIdentifier, staffId) => {
  const reportsListUrl = `reports/available?staffId=${staffId}`;
  const reportDataUrl = `reports/${uniqueIdentifier}`;

  return apiCall(reportsListUrl, 'get')
  .then((response) => {
    const reportsList = response.data.entries;
    const reportIdx = reportsList.findIndex(report => report.uniqueKey === uniqueIdentifier);
    const reportDetails = reportsList[reportIdx];

    return apiCall(reportDataUrl, 'get', {}, 'blob', reportDetails.contentType);
  });
};

export default fetchReport;
